
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import NewVoteButton from '@/components/next/NewVoteButton.vue';
import { Icon } from 'vant';
import { voteDetail } from '../api';

Vue.use(Icon);
@Component({
  components: {
    NewVoteButton,
  },
})
export default class PeopleDetail extends Vue {
  voteName: string = '2022project/q2/2022economics_vote';
  shareTitle: string = '';
  shareSubtitle: string = '';
  shareCover: string = '';
  item: any = {};
  async activated() {
    const res: any = await voteDetail(this.$route.query.id as string);
    this.item = res.data;
    this.shareTitle = this.item.share_title;
    this.shareSubtitle = this.item.share_subtitle;
    this.shareCover = this.item.share_cover;
    this.onRouteChange(res.data);
  }

  onRouteChange(data: any) {
    // 设置分享文案
    const cover = this.shareCover;
    // App分享
    this.$appShareInfo({
      title: data.share_title,
      url: location.href,
      subtitle: data.share_subtitle,
      classId: -1,
      id: -1,
      image: data.share_cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: data.share_title,
        subtitle: data.share_subtitle,
        image: data.share_cover,
      });
    }
  }
  votSuccess(data: any, index: any) {
    this.item.votes = data;
    this.$emit('like');
  }
}
